/**
 * House Of Brand - Shopify Theme JavaScript
 */

document.addEventListener('DOMContentLoaded', function () {
  // Initialize all modules
  PosterSlider.init();
  BrandsCarousel.init();
  ReviewsCarousel.init();
  BackToTop.init();
  ProductGallery.init();
  QuantitySelector.init();
  ScrollReveal.init();
});

// Scroll Reveal — makes .reveal elements visible when they enter the viewport
var ScrollReveal = {
  init: function() {
    var revealEls = document.querySelectorAll('.reveal');
    if (!revealEls.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      revealEls.forEach(function(el) { observer.observe(el); });
    } else {
      // Fallback: just show everything immediately
      revealEls.forEach(function(el) { el.classList.add('visible'); });
    }
  }
};

// Poster/Banner Slider
var PosterSlider = {
  init: function() {
    var self = this;
    this.slides = document.querySelectorAll('.poster-slide');
    this.dots = document.querySelectorAll('.poster-dot');
    this.currentSlide = 0;
    this.autoPlayInterval = null;

    if (this.slides.length > 1) {
      this.startAutoPlay();

      this.dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { 
          self.stopAutoPlay();
          self.goToSlide(i); 
          self.startAutoPlay();
        });
      });

      // Swipe logic for mobile
      var touchStartX = 0;
      var touchEndX = 0;
      var slider = document.querySelector('.hero-posters') || document.querySelector('.poster-slider') || document.body;

      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, {passive: true});

      slider.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        self.handleSwipe(touchStartX, touchEndX);
      }, {passive: true});
    }
  },

  startAutoPlay: function() {
    var self = this;
    if (this.autoPlayInterval) clearInterval(this.autoPlayInterval);
    this.autoPlayInterval = setInterval(function() { self.nextSlide(); }, 4000);
  },

  stopAutoPlay: function() {
    if (this.autoPlayInterval) clearInterval(this.autoPlayInterval);
  },

  handleSwipe: function(startX, endX) {
    var self = this;
    // Swipe Left (Next)
    if (startX - endX > 50) {
      self.stopAutoPlay();
      self.nextSlide();
      self.startAutoPlay();
    } 
    // Swipe Right (Prev)
    else if (endX - startX > 50) {
      self.stopAutoPlay();
      self.prevSlide();
      self.startAutoPlay();
    }
  },

  nextSlide: function() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.goToSlide(this.currentSlide);
  },

  prevSlide: function() {
    this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.goToSlide(this.currentSlide);
  },

  goToSlide: function(index) {
    this.slides.forEach(function(s) { s.classList.remove('active'); });
    this.dots.forEach(function(d) { d.classList.remove('active'); });
    if (this.slides[index]) this.slides[index].classList.add('active');
    if (this.dots[index]) this.dots[index].classList.add('active');
    this.currentSlide = index;
  }
};

// Brands Carousel
var BrandsCarousel = {
  init: function() {
    var self = this;
    this.track = document.getElementById('brandsTrack');
    this.prevBtn = document.getElementById('brandPrev');
    this.nextBtn = document.getElementById('brandNext');

    if (this.track) {
      if (this.prevBtn) this.prevBtn.addEventListener('click', function() { self.scroll(-250); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function() { self.scroll(250); });
    }
  },

  scroll: function(amount) {
    this.track.scrollBy({ left: amount, behavior: 'smooth' });
  }
};

// Customer Reviews Carousel
var ReviewsCarousel = {
  init: function() {
    var self = this;
    this.track = document.getElementById('reviewsTrack');
    this.prevBtn = document.querySelector('.reviews-prev');
    this.nextBtn = document.querySelector('.reviews-next');

    if (this.track) {
      if (this.prevBtn) this.prevBtn.addEventListener('click', function() { self.scroll(-300); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function() { self.scroll(300); });

      // Drag to scroll
      var isDown = false;
      var startX;
      var scrollLeft;

      this.track.addEventListener('mousedown', function(e) {
        isDown = true;
        self.track.classList.add('dragging');
        startX = e.pageX - self.track.offsetLeft;
        scrollLeft = self.track.scrollLeft;
      });

      this.track.addEventListener('mouseleave', function() {
        isDown = false;
        self.track.classList.remove('dragging');
      });

      this.track.addEventListener('mouseup', function() {
        isDown = false;
        self.track.classList.remove('dragging');
      });

      this.track.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - self.track.offsetLeft;
        var walk = (x - startX) * 1.5;
        self.track.scrollLeft = scrollLeft - walk;
      });
    }
  },

  scroll: function(amount) {
    this.track.scrollBy({ left: amount, behavior: 'smooth' });
  }
};

// Back to Top Button
var BackToTop = {
  init: function() {
    var self = this;
    this.btn = document.getElementById('backToTop');
    
    if (this.btn) {
      window.addEventListener('scroll', function() {
        if (window.scrollY > 300) {
          self.btn.classList.add('visible');
        } else {
          self.btn.classList.remove('visible');
        }
      });

      this.btn.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }
};

// Product Gallery
var ProductGallery = {
  init: function() {
    var thumbnails = document.querySelectorAll('.product-thumbnail');
    var mediaItems = document.querySelectorAll('.main-media-item');

    if (thumbnails.length && mediaItems.length) {
      thumbnails.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var targetId = this.getAttribute('data-media-id');
          if (!targetId) return;

          // Toggle active class on thumbnails
          thumbnails.forEach(function(t) { t.classList.remove('active'); });
          this.classList.add('active');

          // Toggle display on main media items
          mediaItems.forEach(function(item) {
            var itemId = item.getAttribute('data-media-id');
            if (itemId === targetId) {
              item.classList.add('active');
              item.style.display = 'block';
              
              // If this item contains an HTML5 video, play it
              var video = item.querySelector('video');
              if (video) {
                video.play().catch(function(e) {
                  console.log("Autoplay prevented:", e);
                });
              }
            } else {
              item.classList.remove('active');
              item.style.display = 'none';

              // If this item contains an HTML5 video, pause it
              var video = item.querySelector('video');
              if (video) {
                video.pause();
              }

              // If this item contains an iframe (YouTube/Vimeo), reset src to stop playback
              var iframe = item.querySelector('iframe');
              if (iframe) {
                var currentSrc = iframe.src;
                iframe.src = '';
                iframe.src = currentSrc;
              }
            }
          });
        });
      });
    }
  }
};

// Quantity Selector
var QuantitySelector = {
  init: function() {
    document.querySelectorAll('.quantity-selector').forEach(function(selector) {
      var input = selector.querySelector('input');
      var minusBtn = selector.querySelector('.qty-minus');
      var plusBtn = selector.querySelector('.qty-plus');

      if (input && minusBtn && plusBtn) {
        minusBtn.addEventListener('click', function() {
          var currentVal = parseInt(input.value) || 1;
          if (currentVal > 1) {
            input.value = currentVal - 1;
            input.dispatchEvent(new Event('change'));
          }
        });

        plusBtn.addEventListener('click', function() {
          var currentVal = parseInt(input.value) || 1;
          var max = parseInt(input.max) || 99;
          if (currentVal < max) {
            input.value = currentVal + 1;
            input.dispatchEvent(new Event('change'));
          }
        });
      }
    });
  }
};

// Add to Cart Animation
function addToCartAnimation(button) {
  button.classList.add('adding');
  setTimeout(function() {
    button.classList.remove('adding');
    button.classList.add('added');
    setTimeout(function() {
      button.classList.remove('added');
    }, 2000);
  }, 500);
}
